import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './router.jsx'
import './index.css'
import { Toaster } from 'react-hot-toast'
import { ErrorBoundary } from './components/ErrorBoundary.jsx'
import { useAppInitialization } from './hooks/useAppInitialization.js'

function SeryiadsRoot() {
  // Inicializa la sesión global (Supabase -> Zustand)
  useAppInitialization();
  
  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" />
    </>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <SeryiadsRoot />
    </ErrorBoundary>
  </StrictMode>,
)

// Agresivo "Cache Buster": Desregistrar Service Worker y borrar cachés locales antiguas
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('Service Worker forzado a desregistrarse para limpiar caché.');
    }
  });
  
  // Limpiar cachés del DOM
  if ('caches' in window) {
    caches.keys().then((names) => {
      for (let name of names) {
        caches.delete(name);
      }
    });
  }
}
